<template lang="html">
  <div class="notification is-danger">
  <button class="delete" @click="onClose" :value="true"></button>
  {{ text }}
</div>
</template>

<script>
export default {
  props: ['text'],
  methods: {
    onClose () {
      this.$emit('dismissed')
    }
  }
}
</script>

<style lang="css">
</style>
